import { NetzbetreiberType } from './netzbetreibertype';
import { KaskadenKontakt } from './kaskaden-kontakt';
import { Adresse } from './adresse';
import { Kundenbetreuer } from './kundenbetreuer';
import { Schaltleitung } from './schaltleitung';
import { Reduzierungsarten } from '../reduzierungsarten';

export class Netzbetreiber implements UniqueTeilgebietAndNetzbetreibernummer {
    public name: string;
    public stadtwerkeId: string;
    public teilgebiet: string;
    public dienstleistungsartTitle: string;
    public netzbetreibernummer: string;
    public netzbetreiberType: NetzbetreiberType;
    public lastChanged: string;
    public kaskadenKontakt: KaskadenKontakt;
    public dueClass?: string; // dynamically added in order to mark Netzbetreiber that needs to confirm their data
    public adresse: Adresse;
    public schaltleitungen: Schaltleitung[];
    public kundenbetreuer: string;
    public kundenbetreuerList: Kundenbetreuer[] = [];
    public reduzierungsarten: Reduzierungsarten;
    public datenAbfrageAktiv: boolean = false;
    public erzeugungsAnlagenPflegeAktiv: boolean = false;

    constructor(
        name: string,
        stadtwerkeId: string,
        teilgebiet: string,
        netzbetreibernummer: string,
        netzbetreiberType: NetzbetreiberType,
        reduzierungsarten: Reduzierungsarten,
        datenAbfrageAktiv: boolean,
    ) {
        this.name = name;
        this.stadtwerkeId = stadtwerkeId;
        this.teilgebiet = teilgebiet;
        this.netzbetreibernummer = netzbetreibernummer;
        this.netzbetreiberType = netzbetreiberType;
        this.reduzierungsarten = reduzierungsarten;
        this.datenAbfrageAktiv = datenAbfrageAktiv;
    }

    public static createEmptyNetzbetreiber(): Netzbetreiber {
        const nb = new Netzbetreiber(
            null,
            null,
            null,
            null,
            'STADTWERK',
            new Reduzierungsarten(),
            false);
        nb.kaskadenKontakt = new KaskadenKontakt();
        nb.adresse = new Adresse();
        nb.schaltleitungen = [];
        return nb;
    }
}

export interface UniqueTeilgebietAndNetzbetreibernummer {
    teilgebiet: string;
    netzbetreibernummer: string;
}

